import { t, Trans } from "@lingui/macro";
import { cn } from "@reactive-resume/utils";

type Props = {
  className?: string;
};

export const Copyright = ({ className }: Props) => (
  <div
    className={cn(
      "prose prose-sm prose-zinc flex max-w-none flex-col gap-y-0.5 text-xs opacity-40 dark:prose-invert text-[10px]",
      className,
    )}
  >
    <span>
      <Trans>
        <a
          target="_blank"
          rel="noopener noreferrer nofollow"
          href="https://resumotion.com/terms-of-service"
        >
          License
        </a>
      </Trans>
      {" & "}
      <Trans>
        <a
          target="_blank"
          rel="noopener noreferrer nofollow"
          href="https://resumotion.com/privacy-policy"
        >
          Privacy Policy
        </a>
      </Trans>
    </span>

    <span>
      <Trans>
        This application is based on
        <span>{" "}</span>
        <a
          target="_blank"
          rel="noopener noreferrer nofollow"
          href="https://github.com/AmruthPillai/Reactive-Resume"
        >
          Reactive Resume
        </a>
        .
      </Trans>
      <Trans>
        <p className="my-0">Copyright (c) 2023 Amruth Pillai.</p>
      </Trans>
    </span>

    {/*<span className="mt-4">*/}
    {/*  {t`Resumotion`} {"v" + appVersion}*/}
    {/*</span>*/}
  </div>
);
